export default __webpack_public_path__ + "static/media/PlanesGcode.bf6e79d4.jpg";